import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import './RemoveOffer.scss';
import { Button, EButtonType } from '@repo/apg-ui';

interface Props {
  basketId: string;
  name: string;
  customer: string;
  offerId: string;
  onClose: any;
  onSuccess: any;
  removeBasket: any;
}

const RemoveOfferModal = ({ onClose, name, offerId, customer, removeBasket, basketId }: Props) => {
  return (
    <div className='remove-offer-modal' id='root'>
      <div className='close-modal'>
        <Button onClick={onClose}>
          <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
          <RedxIcon />
        </Button>
      </div>
      <div className={'m-4 pt-24 d-flex flex-column'}>
        <p>
          <FormattedMessage
            id='ec.confirmation.removeOfferConfirmation'
            defaultMessage='Wollen Sie die Reservierung aufheben?'
          />
        </p>
        <p>
          <b>
            {offerId} - {customer}: {name}
          </b>
        </p>
      </div>
      <div className={'m-4 d-flex justify-content-between'}>
        <Button onClick={onClose} buttonType={EButtonType.InvertedPillMedium}>
          <FormattedMessage id='ec.confirmation.no' defaultMessage='Nein' />
        </Button>
        <Button
          onClick={() => {
            removeBasket(basketId).then(() => {
              onClose();
            });
          }}
          buttonType={EButtonType.PillMedium}
        >
          <FormattedMessage id='ec.confirmation.yes' defaultMessage='Ja' />
        </Button>
      </div>
    </div>
  );
};

export default RemoveOfferModal;
